var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_c('g-tag',{attrs:{"theme":_vm.color}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(_vm.isPaidToAgent)?_c('g-tag',[_vm._v("Paid to Agent")]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }